import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';
import { useActiveOrganization } from '@/features/organization/active-organization-context';
import { SelectOrganizationPage } from '@/features/organization/select-organization-page';

/**
 * Blocks tenant-scoped screens behind Active Organization resolution
 * (ADR-026 Addendum, AO-5). A single membership auto-selects and this
 * gate is never visible; more than one membership with no valid stored
 * selection shows an explicit selection screen instead of guessing.
 * Sits inside `ProtectedRoute` - authentication is already established
 * by the time this runs.
 */
export function RequireActiveOrganization(): ReactNode {
  const { status } = useActiveOrganization();

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center" role="status">
        <Skeleton className="h-8 w-32" />
      </div>
    );
  }

  if (status === 'selecting') {
    return <SelectOrganizationPage />;
  }

  return <Outlet />;
}
